import React, { useState, useEffect } from 'react';

const ImageSlide = ({ path, setCurrentSlide, currentSlide, adds }) => {
    return (
        <img src={path} alt="adds-img" />
    );
};

export default ImageSlide;
